<template>
	<div class="scene-base"></div>
</template>

<script lang="ts">
	import ViewBase from '@/Core/View.vue';
	import { Component } from 'vue-property-decorator';

	/**
	 * @author Matt Kenefick <matt@chalkysticks.com>
	 * @package Core
	 * @project ChalkySticks App
	 */
	@Component
	export default class SceneBase extends ViewBase {
		// Not implemented
	}
</script>
